export const CONFIRMATION_CONCURRENT_STORE_KEY = 'CONFIRMATION';
